import React, {useState} from 'react'
import ControlCenter from '../control-center-my-accounts/control-center'

const AdminControlCenterScreen = () => {
  const [keapPartnerInfo, setKeapPartnerInfo] = useState(undefined)

  return (
    <>
      <form
        onSubmit={e => {
          e.preventDefault()
          const keapPartnerId = e.target.keapPartnerId.value
          setKeapPartnerInfo({keapPartnerId})
        }}
        style={{
          display: 'flex',
          gap: '16px',
          alignItems: 'center',
          marginLeft: '16px',
          marginBlock: '16px',
        }}
      >
        <label style={{marginBottom: '0'}}>Keap Partner ID:</label>
        <input
          type="text"
          name="keapPartnerId"
          className="input-search"
          style={{
            border: '1px solid #ededf2',
            borderRadius: '4px',
            paddingLeft: '8px',
            width: '40%',
            height: '32px',
          }}
          placeholder="Search by Keap Partner ID"
        />
        <button
          type="submit"
          style={{
            background: '#ff5000',
            color: '#fff',
            border: 'none',
            padding: '2px 14px',
            borderRadius: '4px',
            cursor: 'pointer',
            height: '32px',
          }}
        >
          SEARCH
        </button>
      </form>

      {keapPartnerInfo && (
        <ControlCenter
          keapPartnerId={keapPartnerInfo.keapPartnerId}
        ></ControlCenter>
      )}

      {!keapPartnerInfo && (
        <div
          style={{
            display: 'flex',
          }}
        >
          <h4
            style={{
              marginLeft: '16px',
              margin: 'auto',
              marginTop: '30vh',
            }}
          >
            Enter a valid Keap Partner ID to search
          </h4>
        </div>
      )}
    </>
  )
}

export default AdminControlCenterScreen
